import { render, staticRenderFns } from "./BacktestForecast.vue?vue&type=template&id=6b0aeea9&scoped=true"
import script from "./BacktestForecast.vue?vue&type=script&lang=js"
export * from "./BacktestForecast.vue?vue&type=script&lang=js"
import style0 from "./BacktestForecast.vue?vue&type=style&index=0&id=6b0aeea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0aeea9",
  null
  
)

export default component.exports